import React, { useState, useEffect, useRef } from "react";
import "./Shapes.css"; // Import CSS

const shapes = ["circle", "square", "triangle"];
const colors = ["red", "blue", "green"];
const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];

const getRandomItem = (arr) => arr[Math.floor(Math.random() * arr.length)];
const getRandomNumber = () => Math.floor(Math.random() * 9) + 1;

const sequenceLength = 10;

const calculateScore = (user, correct) => {
  let score = 0;
  let table = getResultTable(user, correct);
  const scoreMap = [0, 1, 10, 100];

  table.forEach((row) => {
    let numCorrect = 0;

    row.forEach((e) => {
      //console.log(e)
      if (e) {
        numCorrect += 1;
      }
    });

    score += scoreMap[numCorrect];
  });

  return score;
};

const getResultTable = (user, correct) => {
  let table = [];
  for (let i = 0; i < sequenceLength; i++) {
    table.push([
      user[i].shape === correct[i].shape,
      user[i].color === correct[i].color,
      user[i].number === correct[i].number,
    ]);
  }

  return table;
};

const ShapeGame = () => {
  const [sequence, setSequence] = useState([]);
  const [currentItem, setCurrentItem] = useState(null);
  const [userShape, setUserShape] = useState("circle");
  const [userColor, setUserColor] = useState("red");
  const [userNumber, setUserNumber] = useState(1);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showInput, setShowInput] = useState(false); // Ensures input panel is shown after sequence
  const [shapeSelected, setShapeSelected] = useState(false);
  const [colorSelected, setColorSelected] = useState(false);
  const [guessesMade, setGuessesMade] = useState(0);
  const [userGuesses, setUserGuesses] = useState([]);
  const [isShowSequence, setShowSequence] = useState(false);
  const [displayedItems, setDisplayedItems] = useState([]); // Stores all displayed pairs
  const [showScoreBanner, setShowScoreBanner] = useState(false);
  const [score, setScore] = useState(0);
  const [resultTable, setResultTable] = useState([[]]);
  const lastShapeRef = useRef(null);
  const [showEndGameButtons, setShowEndGameButtons] = useState(false);

  useEffect(() => {
    if (isPlaying) {
      let index = 0;

      console.log(sequence);

      const interval = setInterval(() => {
        if (index < sequenceLength) {
          setCurrentItem(sequence[index]);
          index++;
        } else {
          clearInterval(interval);
          setShowInput(true); // Show input after sequence ends
          //console.log(showInput && !isPlaying)
        }
      }, 1000);
    }
  }, [isPlaying]);

  useEffect(() => {
    if (isShowSequence) {
      let index = -1;
      //console.log(sequence)
      //console.log(userGuesses)
      const interval = setInterval(() => {
        if (index < sequenceLength - 1) {
          setDisplayedItems((prevItems) => [
            ...prevItems,
            {
              correct: sequence[index] || {
                shape: "?",
                color: "gray",
                number: "?",
              },
              user: userGuesses[index] || {
                shape: "?",
                color: "gray",
                number: "?",
              },
            },
          ]);
          index++;
        } else {
          clearInterval(interval);
          setTimeout(() => {
            //console.log(sequence[0].shape)
            setResultTable(getResultTable(sequence, userGuesses));
            setScore(calculateScore(sequence, userGuesses)); // Call your scoring function
            setShowScoreBanner(true); // Show the banner after sequence ends
            setShowEndGameButtons(true);;
          }, 500);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isShowSequence]);

  useEffect(() => {
    if (lastShapeRef.current) {
      lastShapeRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [displayedItems]);

  const handleStart = () => {
    setUserShape("circle");
    setUserColor("red");
    setUserNumber(1);
    setCurrentItem(null);
    setShowInput(false);
    setIsPlaying(true);

    let tempSequence = [];

    for (let i = 0; i < 10; i++) {
      const newItem = {
        shape: getRandomItem(shapes),
        color: getRandomItem(colors),
        number: getRandomNumber(),
      };
      tempSequence.push(newItem);
    }

    setSequence(tempSequence);
  };

  const handleSubmit = () => {
    setIsPlaying(false);
    alert(`Correct sequence: ${JSON.stringify(sequence)}`);
  };

  const handleShapeSelection = (shape) => {
    setUserShape(shape);
    setShapeSelected(true);
  };

  const handleColorSelection = (color) => {
    setUserColor(color);
    setColorSelected(true);
  };

  const handleNumberSelection = (number) => {
    setUserNumber(number);

    setShapeSelected(false);
    setColorSelected(false);

    const newItem = {
      shape: userShape,
      color: userColor,
      number: number,
    };
    userGuesses.push(newItem);

    if (guessesMade === sequenceLength - 1) {
      setShowInput(false);
      //setIsPlaying(false);
      setCurrentItem(null);
      setUserGuesses(userGuesses);
      setIsPlaying(false);
      setShowSequence(true);
    }

    setGuessesMade((guessesMade) => guessesMade + 1);
  };

  return (
    <div style={{ textAlign: "center", fontFamily: "Garammond" }}>
      <h1>Memory Game</h1>

      {/* Show the sequence of shapes to memorize */}
      {isPlaying && currentItem && !showInput && (
        <div className="shape-container">
          {currentItem.shape === "circle" && (
            <div
              className="circle"
              style={{ backgroundColor: currentItem.color }}
            ></div>
          )}
          {currentItem.shape === "square" && (
            <div
              className="square"
              style={{ backgroundColor: currentItem.color }}
            ></div>
          )}
          {currentItem.shape === "triangle" && (
            <div
              className="triangle"
              style={{ borderBottom: `100px solid ${currentItem.color}` }}
            ></div>
          )}
          <span className="number">{currentItem.number}</span>
        </div>
      )}

      {isShowSequence && displayedItems.length > 0 && displayedItems && (
        <div style={{ display: "flex", justifyContent: "center", gap: "50px" }}>
          {/* Correct Sequence Column */}
          <div>
            <h3>Correct Sequence</h3>

            {displayedItems.map((item, idx) => (
              <div
                key={idx}
                className="shape-container"
                ref={idx === displayedItems.length - 1 ? lastShapeRef : null}
              >
                {item.correct.shape === "circle" && (
                  <div
                    className="circle"
                    style={{ backgroundColor: item.correct.color }}
                  ></div>
                )}
                {item.correct.shape === "square" && (
                  <div
                    className="square"
                    style={{ backgroundColor: item.correct.color }}
                  ></div>
                )}
                {item.correct.shape === "triangle" && (
                  <div
                    className="triangle"
                    style={{
                      borderBottom: `100px solid ${item.correct.color}`,
                    }}
                  ></div>
                )}
                <span className="number">{item.correct.number}</span>
              </div>
            ))}
          </div>

          {/* User's Guesses Column */}
          <div>
            <h3>Your Guesses</h3>
            {displayedItems.map((item, idx) => (
              <div key={idx} className="shape-container">
                {item.user.shape === "circle" && (
                  <div
                    className="circle"
                    style={{ backgroundColor: item.user.color || "gray" }}
                  ></div>
                )}
                {item.user.shape === "square" && (
                  <div
                    className="square"
                    style={{ backgroundColor: item.user.color || "gray" }}
                  ></div>
                )}
                {item.user.shape === "triangle" && (
                  <div
                    className="triangle"
                    style={{ borderBottom: `100px solid ${item.user.color}` }}
                  ></div>
                )}
                <span className="number">{item.user.number}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Start screen with instructions */}
{!isPlaying && !showInput && !isShowSequence && (
  <div style={{ textAlign: "center", marginTop: "20px", padding: "20px", maxWidth: "600px", margin: "auto", background: "#f9f9f9", borderRadius: "10px", boxShadow: "0px 0px 10px rgba(0,0,0,0.2)" }}>
    <h2>Welcome to the Memory Game!</h2>
    <p style={{ fontSize: "16px", color: "#555" }}>
      You will see a sequence of shapes, colors, and numbers appear one by one. <br />
      Once the sequence is complete, try to recall and enter the correct order. <br />
      Your final score will be based on how accurately you remember them!
    </p>
    <button 
      onClick={handleStart} 
      style={{ 
        padding: "12px 20px", 
        fontSize: "16px", 
        background: "#007bff", 
        color: "white", 
        border: "none", 
        borderRadius: "5px", 
        cursor: "pointer",
        marginTop: "10px"
      }}
    >
      🎮 Start Game
    </button>
  </div>
)}

      {/* Display input panel once the sequence ends */}
      {showInput && (
        <div>
          {/* Shape Selection */}
          {/* Shape Selection with Visuals */}
          {!shapeSelected && (
            // Shape Selection
            <div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {shapes.map((shape, idx) => (
                  <div
                    key={idx}
                    onClick={() => handleShapeSelection(shape)}
                    className="shape-container"
                    style={{ scale: ".75", cursor: "pointer" }}
                  >
                    {shape === "circle" && (
                      <div
                        className="circle"
                        style={{ backgroundColor: "gray" }}
                      ></div>
                    )}
                    {shape === "square" && (
                      <div
                        className="square"
                        style={{ backgroundColor: "gray" }}
                      ></div>
                    )}
                    {shape === "triangle" && (
                      <div
                        className="triangle"
                        style={{ borderBottom: "100px gray solid" }}
                      ></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {shapeSelected &&
            !colorSelected && ( // Color Selection - Display 3 Shapes in Different Colors
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "20px",
                  }}
                >
                  {colors.slice(0, 3).map((color, idx) => (
                    <div
                      key={idx}
                      onClick={() => handleColorSelection(color)}
                      className="shape-container"
                      style={{ cursor: "pointer" }}
                    >
                      {userShape === "circle" && (
                        <div
                          className="circle"
                          style={{
                            backgroundColor: color,
                            width: "50px",
                            height: "50px",
                          }}
                        ></div>
                      )}
                      {userShape === "square" && (
                        <div
                          className="square"
                          style={{
                            backgroundColor: color,
                            width: "50px",
                            height: "50px",
                          }}
                        ></div>
                      )}
                      {userShape === "triangle" && (
                        <div
                          className="triangle"
                          style={{
                            borderBottom: `100px solid ${color}`,
                            borderLeft: "50px solid transparent",
                            borderRight: "50px solid transparent",
                            width: 0,
                            height: 0,
                          }}
                        ></div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

          {/* Number Selection after Shape and Color are selected */}
          {shapeSelected && colorSelected && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)", // 3 columns per row
                gap: "10px",
                justifyContent: "center",
                width: "100%",
                maxWidth: "350px", // Prevent layout issues
                margin: "auto",
                scale: ".5",
              }}
            >
              {numbers.map((num, idx) => (
                <button key={idx} onClick={() => handleNumberSelection(num)}>
                  <div className="shape-container">
                    {userShape === "circle" && (
                      <div
                        className="circle"
                        style={{ backgroundColor: userColor }}
                      ></div>
                    )}
                    {userShape === "square" && (
                      <div
                        className="square"
                        style={{ backgroundColor: userColor }}
                      ></div>
                    )}
                    {userShape === "triangle" && (
                      <div
                        className="triangle"
                        style={{ borderBottom: `100px solid ${userColor}` }}
                      ></div>
                    )}
                    <span className="number">{num}</span>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      {showScoreBanner && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "white",
            padding: "20px",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
            textAlign: "center",
            borderRadius: "10px",
            width: "250px",
            padding: "20px",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <h2>Game Over!</h2>
          <h3>Your Score: {score}</h3>

          {/* Table Section */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "10px",
              justifyItems: "center",
              alignItems: "center",
              margin: "20px 0",
            }}
          >
            {/* Column Labels */}
            <div style={{ fontWeight: "bold", fontSize: "18px" }}>S</div>
            <div style={{ fontWeight: "bold", fontSize: "18px" }}>C</div>
            <div style={{ fontWeight: "bold", fontSize: "18px" }}>#</div>

            {/* Result Table */}
            {resultTable.flat().map((result, index) => (
              <div key={index} style={{ fontSize: "24px" }}>
                {result ? "✅" : "❌"}
              </div>
            ))}
          </div>

          {/* Buttons */}
          <button
            onClick={() => {
              // Create a table header
              const tableHeader = " S   C   # \n" + "───────────\n";

              // Convert the resultTable array into a text-based table
              const tableBody = resultTable
                .map((row) =>
                  row.map((result) => (result ? "✅" : "❌")).join("   ")
                )
                .join("\n");

              // Full share text
              const shareText = `I scored ${score} in the Shape Memory Game! 🎮✅\n\n${tableHeader}${tableBody}`;

              // Try to share using the native share API
              if (navigator.share) {
                navigator
                  .share({
                    title: "Shape Memory Game",
                    text: shareText,
                  })
                  .catch((error) => console.log("Sharing failed:", error));
              } else {
                alert("Sharing is not supported on this device.");
              }
            }}
            style={{ padding: "10px", marginTop: "10px" }}
          >
            📢 Share Score
          </button>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: "10px", marginLeft: "10px" }}
          >
            🔄 Play Again
          </button>

          <button
            onClick={() => setShowScoreBanner(false)}
            style={{
              padding: "10px",
              marginTop: "10px",
              marginLeft: "20px", // More space from other buttons
              background: "red",
              color: "white",
              border: "none",
              borderRadius: "5px",
              minWidth: "50px", // Ensures a proper clickable size
              textAlign: "center",
            }}
          >
            ❌ Close
          </button>
        </div>
      )}
      {showEndGameButtons && (
        <div style={{ textAlign: "center", marginTop: "20px" }} ref={lastShapeRef}>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 20px",
              margin: "10px",
              background: "green",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            🔄 Play Again
          </button>

          <button
           
            onClick={() => {
              setShowScoreBanner(true);
              setShowEndGameButtons(false);
            }}
            style={{
              padding: "10px 20px",
              margin: "10px",
              background: "blue",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            📊 View Score
          </button>
        </div>
      )}
    </div>
  );
};

export default ShapeGame;
